import { keep1Decimal, keepNumber } from '@assets/js/regExUtil';

export const eChatsOptions1 = {
  tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
  legend: {},
  grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
  xAxis: { type: 'value' },
  yAxis: { type: 'category', data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] },
  series: [
    {
      name: '总数',
      type: 'bar',
      stack: 'total',
      label: { show: true },
      emphasis: { focus: 'series' },
      data: [320, 302, 301, 334, 390, 330, 320]
    },
    {
      name: '款数',
      type: 'bar',
      stack: 'total',
      label: { show: true },
      emphasis: { focus: 'series' },
      data: [120, 132, 101, 134, 90, 230, 210]
    }
  ]
};
export const eChatsOptions2 = {
  title: { text: '产值金额', subtext: '', left: 'center' },
  tooltip: { trigger: 'item' },
  legend: { orient: 'vertical', left: 'left' },
  series: [
    {
      name: '金额',
      type: 'pie',
      radius: '50%',
      data: [
        { value: 1048, name: 'Search Engine' },
        { value: 735, name: 'Direct' },
        { value: 580, name: 'Email' },
        { value: 484, name: 'Union Ads' },
        { value: 300, name: 'Video Ads' }
      ],
      emphasis: {
        itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0, 0, 0, 0.5)' }
      }
    }
  ]
};
export const dialogProperties = [
  { label: '制作难度', prop: 'productionDifficulty', itemType: 'input', input: false },
  {
    label: '最小时长(分钟)',
    prop: 'minimumDuration',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.minimumDuration = keepNumber(val)) }
  },
  {
    label: '最大时长(分钟)',
    prop: 'maximumDuration',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.maximumDuration = keepNumber(val)) }
  },
  {
    label: '样品个数',
    prop: 'numberOfSamples',
    itemType: 'input',
    input: false,
    subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.numberOfSamples = keep1Decimal(val)) }
  }
];
export const styleDialogColumns = [
  // 式样数据弹窗通用列配置：三类共用（手裁/机缝/手工）
  { prop: 'index', type: 'index', labelWidth: '50px', label: '序号' },
  { label: '员工姓名', prop: 'stff_name', itemType: 'input', input: true, sortable: false, widthAuto: true },
  { label: '所属打样间', prop: 'dept_name', itemType: 'input', input: false, sortable: false, widthAuto: true },
  { label: '式样分值', prop: 'style_score', itemType: 'input', input: false, sortable: false, widthAuto: true }
];
// 不可更改
export const buttons = ['开版', '排版', '印花', '制卡', '激光', '电绣', '手裁', '备料', '复合', '机缝', '手工', '检验', '入库', '报价', '数据录入'];
export const buttons2 = [
  '开版师',
  '印花员',
  '制卡员',
  '激光员',
  '电绣员',
  '手裁员',
  '备料员',
  '复合员',
  '机缝工',
  '手工员',
  '入库员',
  '报价员'
];
